function updateSlidesBasedOnWidth() {
  var splideList = document.querySelector('.feature-column-section .splide__list');
  
  if (window.innerWidth < 768) {
    splideList.innerHTML = splideList.dataset.mobSlides;
  } else {
    splideList.innerHTML = splideList.dataset.deskSlides;
  }
}
window.addEventListener('resize', function() {
  // updateSlidesBasedOnWidth();
});


document.addEventListener('DOMContentLoaded', function () {
if(document.querySelector('.feature-column-section .splide__list')){
  // updateSlidesBasedOnWidth();
  window.addEventListener('resize', function() {
    // updateSlidesBasedOnWidth();
  });
}

  const buttons = document.querySelectorAll('nav ul[x-ref="navigation"] li button');
  buttons.forEach(function(button) {
      button.addEventListener('click', function() {
          document.body.classList.toggle('popup');
      });
  });
  
  document.addEventListener('click', function(event) {
      if (
          !event.target.closest('nav ul[x-ref="navigation"] li button') &&
          !event.target.closest('.no-js-focus-container') && 
          document.body.classList.contains('popup')
      ) {
          document.body.classList.remove('popup');
      }
  });

  if(window.location.pathname === "/"){

    var slider = $('.focus_carousel .feature-slider');
    var title = $('.upper_slide_title');
    // $(window).on('load', function() {
    //    $('.resized_image').addClass('transition_start');
    //   // var slider = $('.focus_carousel .feature-slider');
    //   // slider.addClass('transition_start');
    //   // title.addClass('transition_start');
    //   // $('.focus_carousel').addClass('transition_start');
    //   // $('.headerBorderWrap .icon-wrapper').addClass('transition_start');
    //   // $('.headerBorderWrap .menu-wrapper').addClass('transition_start');
      
    //   setTimeout(function() {
    //     // slider.addClass('transition_end');
    //     // title.addClass('transition_end');
    //     $('body').addClass('transition_end');
    //     $('.resized_image').addClass('transition_end');
    //     $('.focus_carousel').addClass('transition_end');
    //     $('.headerBorderWrap .icon-wrapper').addClass('transition_end');
    //     $('.headerBorderWrap .menu-wrapper').addClass('transition_end');
    //     $('.announcement_bar').addClass('transition_end');
    //   }, 1000);
    // });
    
      $(window).on('load', function() {
        function applyTransitionEnd() {
            setTimeout(function() {
                $('body').addClass('transition_end');
                $('.resized_image').addClass('transition_end');
                $('.focus_carousel').addClass('transition_end');
                $('.site-header').addClass('transition_end');
                // $('.announcement_bar').addClass('transition_end');
            }, 1000);
        }
        function applyTransitionStart() {
            $('.resized_image').addClass('transition_start');
        }
    
        // var transitionTimeout = setTimeout(function() {
        //     applyTransitionEnd();
        //     applyTransitionStart();
        // }, 5000);
    
        // $(document).on('mousemove keydown', function() {
        //     clearTimeout(transitionTimeout);
        //     applyTransitionEnd();
        //     applyTransitionStart();
        // });
    });

    slider.slick({
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 3,
        centerMode: true,
        // centerPadding: "20%",
        // draggable: true,
        // swipe: true,
        touchThreshold: 80,
        // touchMove: true,
        // swipeToSlide: true,
        infinite: true,
        arrows: (slider.attr('data-arrows') === 'true'),
        dots: (slider.attr('data-dots') === 'true'),
        responsive: [
          // {
          //       breakpoint: 991,
          //       settings: {
          //           slidesToShow: 3,
          //           // centerPadding: "30%"
          //       }
          // },
          {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    // centerPadding: "30%"
                }
            }
        ]
    });
    
  function updateSlideFooterClasses(slick, currentSlide) {
    var active_slide = currentSlide;
    $('.slide_footer').each(function() {
        $(this).removeClass('slick-current slick-active');
    });
    $('.upr_slide_item').each(function() {
        $(this).removeClass('slick-current slick-active');
    });
    
    $('.slide_footer[data-slick-index="'+active_slide+'"]').addClass('slick-current slick-active');
    $('.upr_slide_item[data-slick-index="'+active_slide+'"]').addClass('slick-current slick-active');
  }
  
  $('.focus_carousel .feature-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      updateSlideFooterClasses(slick, nextSlide);
  });
  
  $('.focus_carousel .feature-slider').on('afterChange', function(event, slick, currentSlide) {
      updateSlideFooterClasses(slick, currentSlide);
  });

 
    var video = document.querySelector('.home_clinical_video video');
    var ask_video = document.querySelector('.home_ask video');
    var result_video = document.querySelector('.home_result_video video');
    const screenWidth = window.innerWidth;
   
    function handleVideoInView(Video) {
        const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // console.log('Video visibility: ', entry.isIntersecting);
            if (entry.isIntersecting) {
                if (Video) {
                    Video.currentTime = 0;
                    Video.play();
                }
            } else {
                if (Video && !Video.paused) {
                    // Video.pause();
                    // Video.currentTime = 0; 
                }
            }
        });
      }, { threshold: 0.5 }); 
      if (Video) {
          observer.observe(Video);
      }
    }
    
    function updateVideoElements() {
      if (screenWidth <= 767) {
          const deskHiddenElement = document.querySelector('.home_clinical_video .desk_hidden');
          if (deskHiddenElement) {
              video = deskHiddenElement.querySelector('video');
          }
  
          const askDeskHiddenElement = document.querySelector('.home_ask .desk_hidden');
          if (askDeskHiddenElement) {
              ask_video = askDeskHiddenElement.querySelector('video');
          }
  
          const resultDeskHiddenElement = document.querySelector('.home_result_video .desk_hidden');
          if (resultDeskHiddenElement) {
              result_video = resultDeskHiddenElement.querySelector('video');
          }
      }
  
      if (video) {
          video.removeAttribute('autoplay');
          video.removeAttribute('loop');
      }
      if (ask_video) {
          ask_video.removeAttribute('autoplay');
          ask_video.removeAttribute('loop');
      }
      if (result_video) {
          result_video.removeAttribute('autoplay');
          result_video.removeAttribute('loop');
      }
  
    }

    function resetVideo() {
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (ask_video) {
            ask_video.pause();
            ask_video.currentTime = 0;
        }
      if (result_video) {
            result_video.pause();
            result_video.currentTime = 0;
        }
    }
    
    function handlePopupAndVideo() {
        const popup = document.querySelector('.needsclick.kl-private-reset-css-Xuajs1');
        
        if (popup) {
            if (video) video.pause();
            if (ask_video) ask_video.pause();
        } else {
            if (video) video.play();
            if (ask_video) ask_video.play();
            if (result_video) result_video.play();
        }
    }
    
    function initialize() {
        updateVideoElements();
        handlePopupAndVideo();
        handleVideoInView(video);
        handleVideoInView(ask_video);
        handleVideoInView(result_video);
      
    }
    
    window.addEventListener('resize', function() {
        updateVideoElements();
        handlePopupAndVideo(); 
    
    });

    initialize();
    
    if (video) {
        video.addEventListener('ended', function() {
            video.pause();
        });
        video.addEventListener('pause', function() {
            if (video.currentTime !== video.duration) {
                resetVideo();
            }
        });
    }
    
    if (ask_video) {
        ask_video.addEventListener('ended', function() {
            ask_video.pause();
        });
        ask_video.addEventListener('pause', function() {
            if (ask_video.currentTime !== ask_video.duration) {
                resetVideo();
            }
        });
    }

    if (result_video) {
        result_video.addEventListener('ended', function() {
            result_video.pause();
        });
        result_video.addEventListener('pause', function() {
            if (result_video.currentTime !== result_video.duration) {
                resetVideo();
            }
        });
    }




      // const isMobile = window.innerWidth <= 768;
      // const mobileThreshold = isMobile ? window.innerHeight * 0.4 : window.innerHeight * 1; 
      // const targetDiv = document.querySelector('.fix-center-image-section .col-span-2 .media');
      // let lastScrollY = window.scrollY; 
      // const sectionStart = document.querySelector('.feature-text-with-image');
      // if (targetDiv) {
      //   const observer = new IntersectionObserver(
      //     (entries) => {
      //       entries.forEach((entry) => {
      //         const scrollDirection = window.scrollY > lastScrollY ? 'down' : 'up';
      //         lastScrollY = window.scrollY;
      //         var rect = entry.target.getBoundingClientRect();
      //         if (scrollDirection === 'down' && rect.top < 0 && rect.bottom > window.innerHeight * 0.001 ) {
      //           targetDiv.classList.add('fixed_image');
      //         } else if (scrollDirection === 'up' && rect.top != 0 && rect.bottom > window.innerHeight * 0.09) {
      //           targetDiv.classList.remove('fixed_image');
      //         }
      //       });
      //     },
      //     {
      //       root: null, 
      //       threshold: isMobile ? [0.001, 0.5] : [0.001, 0.95],
      //     }
      //   );
      //   observer.observe(targetDiv); 
      // }
    
      // const featureSection = document.querySelector('.feature-text-with-image');
      // const mediaSection = document.querySelector('.fix-center-image-section .col-span-2 .media');
      // const fixCenterSection = document.querySelector('.fix-center-image-section');
      
      // if (featureSection) {
      //   const observer = new IntersectionObserver(
      //     (entries) => {
      //       entries.forEach((entry) => {
      //         const scrollDirection = window.scrollY > lastScrollY ? 'down' : 'up';
      //         lastScrollY = window.scrollY;
      //         var rect = entry.target.getBoundingClientRect();
      
      //         if (scrollDirection === 'down' && rect.top < 0 && rect.bottom > window.innerHeight * 0.02) {
      //           targetDiv.classList.add('sticky-image');
      //         } else if (scrollDirection === 'up' && rect.top != 0 && rect.bottom > window.innerHeight * 0.02) {
      //           targetDiv.classList.remove('sticky-image');
      //         }
      //       });
      //     },
      //     {
      //       root: null,
      //       threshold: isMobile ? [0.001, 0.5] : [0.001, 0.85],
      //     }
      //   );
      
      //   observer.observe(featureSection);
      // }

      // if (featureSection && mediaSection && fixCenterSection) {
      //   const toggleCustomClass = () => {
      //     mediaSection.classList.remove('sticky-image');
      //     const featureRect = featureSection.getBoundingClientRect();
      //     const fixCenterRect = fixCenterSection.getBoundingClientRect();
      //     const img = featureSection.querySelector('img');
      //     if (featureRect.top < mobileThreshold && featureRect.bottom > window.innerHeight * 0.68) {
      //         mediaSection.classList.remove('sticky-image');
      //         // featureSection.querySelector('img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0712/4539/8257/files/All_FrontView_Boxes_HR_1_2_5c92595f-7cef-4dfc-8a98-11f02185880d.png?v=1733980463');
      //       } else if (fixCenterRect.top >= window.innerHeight || fixCenterRect.bottom <= 0.2) {
      //         mediaSection.classList.add('sticky-image');
      //         // featureSection.querySelector('img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0712/4539/8257/files/Capture.png?v=1734352260&width=1536');
      //         // featureSection.querySelector('img').removeAttribute('srcset');
      //       }
      //   };
      //   window.addEventListener('scroll', toggleCustomClass, { passive: true });
      //   toggleCustomClass();
      // }

    
    //   document.addEventListener("scroll", () => {
    //     if (document.querySelector('.bottom_video')) {
    //       const targetElement = document.querySelector('.bottom_video');
    //       const scrollPosition = window.scrollY;
      
    //       if (scrollPosition >= 2000) {
    //           targetElement.classList.add('scrolled');
    //       } else {
    //           targetElement.classList.remove('scrolled');
    //       }
    //     }
    // });

  }
  if (window.location.href.indexOf("/products") !== -1) {
    const videoThumbnails = document.querySelectorAll('.media-thumbnail.media-video');
    videoThumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('click', function() {
            const videoElement = document.querySelector('.feature-media-item video');
            if (videoElement) {
                videoElement.play();
            }
        });
    });
  
    window.addEventListener('scroll', function() {
      if(document.querySelector('.fix-center-image-section.pdp_video')){
        var rightHighlight = document.querySelector('.right_highlight');
        var leftHighlight = document.querySelector('.left_highlight');
        var title = document.querySelector('.fix-center-image-section.pdp_video .font-heading');
        var rightHighlightTop = title.getBoundingClientRect().top;
        if (rightHighlightTop < 0) {
          rightHighlight.style.opacity = '0';
          rightHighlight.style.transition = 'opacity 0.5s';
          leftHighlight.style.opacity = '1';
          leftHighlight.style.transition = 'opacity 0.5s';
        } else {
          rightHighlight.style.opacity = '1';
          leftHighlight.style.opacity = '0';
          rightHighlight.style.transition = 'opacity 0.5s';
          leftHighlight.style.transition = 'opacity 0.5s';
        }
      }
    });

    document.querySelectorAll('.feature-tab-heading').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var dataVal = tab.getAttribute('data-value');
        var section = tab.closest('.feature-tabs-section');
    
        section.querySelectorAll('.feature-tab-heading').forEach(function(otherTab) {
          otherTab.classList.remove('active');
        });
    
        tab.classList.add('active');
    
        section.querySelectorAll('.feature-tab-content').forEach(function(content) {
          content.style.display = 'none';
        });
    
        var activeContent = section.querySelector('.feature-tab-content[data-value="' + dataVal + '"]');
        if (activeContent) {
          activeContent.style.display = 'block';
        }
      });
    });

    var slider = $('.testimonials .slick-slider');
    $('.testimonials .slick-slider').slick({
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 2,
        centerPadding: "10%",
        draggable: true,
        swipe: true,
        touchThreshold: 80,
        touchMove: true,
        swipeToSlide: true,
        autoplay: (slider.attr('data-autostart') === 'true'),  
        infinite: true,
        arrows: (slider.attr('data-arrows') === 'true'), 
        dots: (slider.attr('data-dots') === 'true'),
        responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 1,
            centerPadding: "20%"
          }
        }
      ]
    });

    $('.testimonials .slick-slider').slickLightbox({
        src: 'src',
        itemSelector: '.js-gallery-popup img',
        navigateByKeyboard  : true,
        background: 'rgba(0, 0, 0, .7)'
    });
    
    // Step 1: Open the image popup on image click
    // document.querySelectorAll('.testimonials .splide__slide').forEach(function(li) {
    //   li.querySelector('img').addEventListener('click', function() {
    //     document.body.classList.add('image_popup');
    
    //     // Close any currently active image in the popup
    //     document.querySelectorAll('.splide__slide__image.active').forEach(function(image) {
    //       image.classList.remove('active');
    //       image.querySelector('.splide__slide__close').classList.remove('active');
    //     });
    
    //     // Find the parent element of the clicked image that is the `.splide__slide__image`
    //     var currentImage = this.closest('.splide__slide').querySelector('.splide__slide__image');
    //     currentImage.classList.add('active');
    //     currentImage.querySelector('.splide__slide__close').classList.add('active');
    
    //     // Update popup content with the current image's slide
    //     var track = currentImage.closest('.splide__track');
    //     var popup = track.querySelector('.slide_image__popup');
    //     if (popup) {
    //       popup.innerHTML = currentImage.closest('.splide__slide').innerHTML;
    //     }
    //   });
    // });
    
    // // Step 2: Handle the close button click using event delegation
    // var Timeinterval = setInterval(function() {
    //   document.querySelectorAll('.splide__slide__close.active').forEach(function(closeButton) {
    //     closeButton.querySelector('svg').addEventListener('click', function() {
    //       var currentImage = this.closest('.splide__slide__image');
    //       if (currentImage) {
    //         currentImage.classList.remove('active');
    //         currentImage.querySelector('.splide__slide__close').classList.remove('active');
    
    //         // If no active images left, remove the popup
    //         document.body.classList.remove('image_popup');
    
    //         // Clear the popup content 
    //         var track = currentImage.closest('.splide__track');
    //         var popup = track.querySelector('.slide_image__popup');
    //         if (popup) {
    //           popup.innerHTML = '';
    //           // clearInterval(Timeinterval);
    //         }
    //       }
    //     });
    //   });
    // }, 100);

    // function closePopup(){
    //   var isClickInside = event.target.closest('.slide_image__popup .splide__slide__image img');
    //   var popup = document.querySelector('.slide_image__popup .splide__slide__image');
    //   if (popup && !isClickInside) {
    //     document.querySelectorAll('.splide__slide__image.active').forEach(function(image) {
    //       image.classList.remove('active');
    //       image.querySelector('.splide__slide__close').classList.remove('active');
    //       image.closest('.slide_image__popup').innerHTML = '';
    //     });
    //     document.body.classList.remove('image_popup');
    //   }
    // }
    // // Step 3: Close the popup if clicking outside of the image
    // document.addEventListener('click', function(event) {
    //   closePopup();
    // });

    // function popup(interval){
    //   // var interval = setInterval(function() {
    //       var popup = document.querySelector('.slide_image__popup .splide__slide__image');
    //       var activeSlide = document.querySelector('.testimonials .splide__slide.is-active');
    //       // If the popup exists and there's an active slide, update it
    //       if (popup && activeSlide) {
    //         // Remove the active class from any current active images in the popup
    //         document.querySelectorAll('.splide__slide__image.active').forEach(function(image) {
    //           image.classList.remove('active');
    //           var closeButton = image.querySelector('.splide__slide__close');
    //           if (closeButton) closeButton.classList.remove('active');
    //         });
      
    //         // Add the active class to the new active slide's image
    //         var currentSlideImage = activeSlide.querySelector('.splide__slide__image');
    //         if (currentSlideImage) {
    //           currentSlideImage.classList.add('active');
    //           var closeButton = currentSlideImage.querySelector('.splide__slide__close');
    //           if (closeButton) closeButton.classList.add('active');
    //         }
      
    //         // Update the popup's content to match the active slide
    //         popup.closest('.slide_image__popup').innerHTML = activeSlide.innerHTML;
    //         clearInterval(interval);
    //       }
    //     // },1000);
    // }

        // document.addEventListener('touchstart', function (e) {
        //     // var interval = setInterval(function() {
        //     //   popup(interval);
        //     // },100);
        //     // closePopup();
        //     // var Timeinterval = setInterval(function() {
        //     //   document.querySelectorAll('.splide__slide__close.active').forEach(function(closeButton) {
        //     //     closeButton.addEventListener('click', function() {
        //     //       var currentImage = this.closest('.splide__slide__image');
        //     //       if (currentImage) {
        //     //         currentImage.classList.remove('active');
        //     //         currentImage.querySelector('.splide__slide__close').classList.remove('active');
            
        //     //         // If no active images left, remove the popup
        //     //         document.body.classList.remove('image_popup');
            
        //     //         // Clear the popup content 
        //     //         var track = currentImage.closest('.splide__track');
        //     //         var popup = track.querySelector('.slide_image__popup');
        //     //         if (popup) {
        //     //           popup.innerHTML = '';
        //     //           // clearInterval(Timeinterval);
        //     //         }
        //     //       }
        //     //     });
        //     //   });
        //     // }, 100);
        // });
        
      
        // document.addEventListener('touchmove', function (e) {
        //     var interval = setInterval(function() {
        //       popup(interval);
        //     });
        // });

        // if (window.innerWidth < 800) {
        //     document.addEventListener('touchend', function () {
        //         var interval = setInterval(function() {
        //           popup(interval);
        //         },1000);
        //         // closePopup();
        //         // var Timeinterval = setInterval(function() {
        //         //   document.querySelectorAll('.splide__slide__close.active').forEach(function(closeButton) {
        //         //     closeButton.addEventListener('click', function() {
        //         //       var currentImage = this.closest('.splide__slide__image');
        //         //       if (currentImage) {
        //         //         currentImage.classList.remove('active');
        //         //         currentImage.querySelector('.splide__slide__close').classList.remove('active');
                
        //         //         // If no active images left, remove the popup
        //         //         document.body.classList.remove('image_popup');
                
        //         //         // Clear the popup content 
        //         //         var track = currentImage.closest('.splide__track');
        //         //         var popup = track.querySelector('.slide_image__popup');
        //         //         if (popup) {
        //         //           popup.innerHTML = '';
        //         //           // clearInterval(Timeinterval);
        //         //         }
        //         //       }
        //         //     });
        //         //   });
        //         // }, 100);
        //     });
        //   }
      }


});
